import { Injectable } from '@angular/core';
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { ConfigProvider } from "../../config-provider.service";
import { ApiBaseService } from '../../common/providers/api-base-service';
import { CurrentUser } from "../../common/providers/current-user";
import { DiscussionMessage } from '../../common/models/discussion-message';
import { map } from "rxjs/operators";
import { Observable, tap } from "rxjs";
import { PrivateDiscussion } from '../../common/models/private-discussion';
import { User } from "../../common/models/user";
import { PrivateDiscussionUser } from "../../common/models/private-discussion-user";
import { Discussion } from "../../common/models/discussion";

@Injectable({providedIn: 'root'})
export class DiscussionsProvider {
    private _privateDiscussionsData: PrivateDiscussionData[] = [];
    public get privateDiscussionsData() {
        return this._privateDiscussionsData;
    }

    private _activePrivateDiscussions: ActivePrivateDiscussion[] = [];
    public get activePrivateDiscussions() {
        return this._activePrivateDiscussions;
    }

    private _privateDiscussionsDataWithUnreadMessages: PrivateDiscussionData[] = [];
    public get privateDiscussionsDataWithUnreadMessages() {
        return this._privateDiscussionsDataWithUnreadMessages;
    }
    constructor(
        private _conf: ConfigProvider,
        private _utils: UtilsProvider,
        private _api: ApiBaseService,
//        private _storage: ModelsStorage,
        private _currentUser: CurrentUser
    ) {

    }

    // public getSyncListeners(): SyncListener[] {
    //     const privateDiscussionsListener: SyncListener = {
    //         id: '',
    //         onCommonDataSynced: null,
    //         onUserDataSynced: () => {
    //             this.updatePrivateDiscussions();
    //         }
    //     };
    //
    //     return [privateDiscussionsListener];
    // }

    public getPrivateDiscussionUsers(privateDiscussionId: number): Observable<PrivateDiscussionUser[]> {
      return this._api.call('get', `private-discussion/${privateDiscussionId}/users`, {}, this._currentUser.getAccessToken())
        .pipe(
        map((result: PrivateDiscussionUser[]) => PrivateDiscussionUser.fromAPIList(result))
      );
    }

    public updatePrivateDiscussions(): Observable<void> {
      return this.loadPrivateDiscussionsData().pipe(
        tap(() => {
            this.updateActivePrivateDiscussion();
        }),
      );
    }

    public sendNewMessage(api: string, message: DiscussionMessage): Observable<DiscussionMessage> {
        return this._api.call(                'post',
                api,
                { discussionMessage: message.toJson() },
                this._currentUser.getAccessToken()
            ).pipe(
                map((data: any) => {
                    return DiscussionMessage.fromAPI(data.discussionMessage);
                }),
            );
    }

    public deleteMessage(api: string, message: DiscussionMessage): Observable<void> {
        return this._api.call(              'post',
              api,
              { discussionMessage: message.toJson() },
              this._currentUser.getAccessToken()
          );
    }

    public startGroupDiscussion(group: PrivateDiscussion): Observable<any> {
      throw new Error('Method not implemented and not used ? ');
        // return new Promise<any>((resolve, reject) => {
        //     // on check d'abord dans les discussions active si elle existe
        //     //      si c'est le cas
        //     //          si elle est minimisée, on la maximise
        //     //          sinon on fait rien du tout
        //     //      si c'est pas le cas
        //     //          on check si elle existe déjà dans les discussions disponibles
        //     //              si c'est le cas, on ajoute ses données dans la discussion active qu'on a déjà créée
        //     //              si c'est pas le cas, on retourne une erreur
        //     for (let i = 0; i < this._activePrivateDiscussions.length; i++) {
        //         if (this._activePrivateDiscussions[i].data.privateDiscussion.id === group.id) {
        //             if (this._activePrivateDiscussions[i].isMinimized) {
        //                 this._activePrivateDiscussions[i].isMinimized = false;
        //             }
        //
        //             this.updateLastSeen(this._privateDiscussionsData[i].PrivateDiscussionUser)
        //                 .then(() => resolve())
        //                 .catch((error: any) => reject(error));
        //             return;
        //         }
        //     }
        //
        //     for (let i = 0; i < this._privateDiscussionsData.length; i++) {
        //         if (this._privateDiscussionsData[i].privateDiscussion.id === group.id) {
        //             this._activePrivateDiscussions.push({
        //                 data: this._privateDiscussionsData[i],
        //                 isMinimized: false,
        //                 isReady: true
        //             });
        //
        //             this.updateLastSeen(this._privateDiscussionsData[i].PrivateDiscussionUser)
        //                 .then(() => resolve())
        //                 .catch((error: any) => reject(error));
        //             return;
        //         }
        //     }
        //
        //     reject({status: 404, message: 'Private group discussion not found.'});
        // });
    }

    public startOneToOneDiscussion(user: User): Observable<void> {
            // on check d'abord dans les discussions active si elle existe
            //      si c'est le cas
            //          si elle est minimisée, on la maximise
            //          sinon on fait rien du tout
            //      si c'est pas le cas
            //          on check si elle existe déjà dans les discussions disponibles
            //              si c'est le cas, on ajoute ses données dans la discussion active qu'on a déjà créée
            //              si c'est pas le cas
            //                  on check que l'utilisateur n'ait pas été supprimé
            //                      si c'est le cas, on retourne une erreur unknown
            //                      si c'est pas le cas
            //                          on ajoute une dicussion active sans donnée
            //                          on créé la discussion via l'api
            //                          on sauve les données
            //                          on ajoute les données à la liste des discussions disponibles
            //                          on ajoute les données dans la discussion active qu'on a déjà créée
          throw new Error('Method not implemented // not used ??.');

            // for (let i = 0; i < this._activePrivateDiscussions.length; i++) {
            //     if (!this._activePrivateDiscussions[i].data.privateDiscussion.isGroup && this._activePrivateDiscussions[i].data.usersData[0].user.id === user.id) {
            //         if (this._activePrivateDiscussions[i].isMinimized) {
            //             this._activePrivateDiscussions[i].isMinimized = false;
            //         }
            //
            //         this.updateLastSeen(this._privateDiscussionsData[i].PrivateDiscussionUser)
            //             .then(() => resolve())
            //             .catch((error: any) => reject(error));
            //         return;
            //     }
            // }
            //
            // for (let i = 0; i < this._privateDiscussionsData.length; i++) {
            //     if (!this._privateDiscussionsData[i].privateDiscussion.isGroup && this._privateDiscussionsData[i].usersData[0].user.id === user.id) {
            //         this._activePrivateDiscussions.push({
            //             data: this._privateDiscussionsData[i],
            //             isMinimized: false,
            //             isReady: true
            //         });
            //
            //         this.updateLastSeen(this._privateDiscussionsData[i].PrivateDiscussionUser)
            //             .then(() => resolve())
            //             .catch((error: any) => reject(error));
            //         return;
            //     }
            // }
            //
            // if (user.deleteDate) {
            //     reject({ error: 'User has been deleted' });
            //     return;
            // }
            //
            // const randomId: any = this._utils.randomString(16);
            // const tempPrivateDiscussion: PrivateDiscussion = new PrivateDiscussion();
            // tempPrivateDiscussion.id = randomId;
            // const newDiscussion: ActivePrivateDiscussion = {
            //     data: {
            //         privateDiscussion: tempPrivateDiscussion,
            //         PrivateDiscussionUser: new PrivateDiscussionUser(),
            //         usersData: [{
            //             PrivateDiscussionUser: new PrivateDiscussionUser(),
            //             user
            //         }],
            //         discussion: new Discussion(),
            //         messages: [],
            //         unreadMessagesCount: 0
            //     },
            //     isMinimized: false,
            //     isReady: false
            // };
            // this._activePrivateDiscussions.push(newDiscussion);
            // const privateDiscussion: PrivateDiscussion = new PrivateDiscussion();
            // privateDiscussion.isGroup = 0;
            // privateDiscussion.name = null;
            // privateDiscussion.image = null;
            // this.savePrivateDiscussion(privateDiscussion, [user.id])
            //     .then((data: PrivateDiscussionData) => {
            //         newDiscussion.data = data;
            //         newDiscussion.isReady = true;
            //
            //         this.updateLastSeen(data.PrivateDiscussionUser)
            //             .then(() => {
            //                 resolve();
            //             })
            //             .catch((error: any) => reject(error));
            //     })
            //     .catch((error) => {
            //         for (let i = 0; i < this._activePrivateDiscussions.length; i++) {
            //             if (this._activePrivateDiscussions[i].data.privateDiscussion.id === randomId) {
            //                 this._activePrivateDiscussions.splice(i);
            //             }
            //         }
            //
            //         reject(error);
            //     });
    }

    public updateLastSeen(PrivateDiscussionUser: PrivateDiscussionUser): Observable<PrivateDiscussionUser> {
      throw new Error('Method not implemented.');
      // return this._api.call(      //           'post',
      //           'users/' + PrivateDiscussionUser.userId + '/discussions/' + PrivateDiscussionUser.privateDiscussionId + '/messages-seen',
      //           {},
      //           this._currentUser.getAccessToken()
      //       )
      //           .then((data: any) => {
      //               PrivateDiscussionUser = PrivateDiscussionUser.fromAPI(data.PrivateDiscussionUser);
      //               this._storage.save([PrivateDiscussionUser])
      //                   .then(() => {
      //                       for (let i = 0; i < this._privateDiscussionsData.length; i++) {
      //                           if (this._privateDiscussionsData[i].PrivateDiscussionUser.id === PrivateDiscussionUser.id) {
      //                               const unreadMessagesCount: number = this.countUnreadMessages(PrivateDiscussionUser, this._privateDiscussionsData[i].messages);
      //                               let hadUnreadMessages = false;
      //                               for (let j = 0; !hadUnreadMessages && j < this._privateDiscussionsDataWithUnreadMessages.length; j++) {
      //                                   if (this._privateDiscussionsDataWithUnreadMessages[j].PrivateDiscussionUser.id === PrivateDiscussionUser.id) {
      //                                       hadUnreadMessages = true;
      //                                       if (unreadMessagesCount === 0) {
      //                                           this._privateDiscussionsDataWithUnreadMessages.splice(j, 1);
      //                                       }
      //                                   }
      //                               }
      //
      //                               if (!hadUnreadMessages && unreadMessagesCount > 0) {
      //                                   this._privateDiscussionsDataWithUnreadMessages.push(this._privateDiscussionsData[i]);
      //                               }
      //
      //                               this._privateDiscussionsData[i].PrivateDiscussionUser = PrivateDiscussionUser;
      //                               this._privateDiscussionsData[i].unreadMessagesCount = unreadMessagesCount;
      //                               resolve(PrivateDiscussionUser);
      //                               return;
      //                           }
      //                       }
      //
      //                       reject({error: 'Failed to update PrivateDiscussionUser in provider'});
      //                   })
      //                   .catch((error: any) => reject(error));
      //           })
      //           .catch((error: any) => reject(error));
      //   });
    }

    public closePrivateDiscussion(activePrivateDiscussion: ActivePrivateDiscussion): void {
        for (let i = 0; i < this._activePrivateDiscussions.length; i++) {
            if (this._activePrivateDiscussions[i].data.privateDiscussion.id === activePrivateDiscussion.data.privateDiscussion.id) {
                this._activePrivateDiscussions.splice(i, 1);
                return;
            }
        }
    }

    public savePrivateDiscussion(privateDiscussion: PrivateDiscussion, userIds: number[]): Observable<PrivateDiscussion> {
      throw new Error('Method not implemented.');
        //     return this._api.call(        //         'post',
        //         'users/' + this._currentUser.user.id + '/discussions/' + (privateDiscussion.id ? privateDiscussion.id : 0),
        //         {
        //             userIds,
        //             isGroup: privateDiscussion.isGroup ? 1 : 0,
        //             name: privateDiscussion.name,
        //             image: privateDiscussion.image
        //         },
        //         this._currentUser.getAccessToken()
        //     )
        //         .then((data: any) => {
        //             privateDiscussion = PrivateDiscussion.fromAPI(data.privateDiscussion);
        //             const PrivateDiscussionUsers: PrivateDiscussionUser[] = PrivateDiscussionUser.fromAPIList(data.PrivateDiscussionUsers);
        //             const discussion: Discussion = Discussion.fromAPI(data.discussion);
        //             Promise.all([
        //                 this._storage.save([discussion]),
        //                 this._storage.save([privateDiscussion]),
        //                 this._storage.save(PrivateDiscussionUsers),
        //                 this._storage.select(User).get()
        //             ])
        //                 .then((storageData: any[]) => {
        //                     const PrivateDiscussionUser: PrivateDiscussionUser = this._utils.findIn(this._currentUser.user.id, PrivateDiscussionUsers, 'userId');
        //                     let messages: DiscussionMessage[] = [];
        //                     let unreadCount = 0;
        //                     let dataIndex = -1;
        //                     for (let i = 0; i < this._privateDiscussionsData.length; i++) {
        //                         if (this._privateDiscussionsData[i].privateDiscussion.id === privateDiscussion.id) {
        //                             dataIndex = i;
        //                             messages = this._privateDiscussionsData[i].messages;
        //                             unreadCount = this._privateDiscussionsData[i].unreadMessagesCount;
        //                             i = this._privateDiscussionsData.length;
        //                         }
        //                     }
        //                     const usersData: PrivateDiscussionUserData[] = [];
        //                     for (let j = 0; j < PrivateDiscussionUsers.length; j++) {
        //                         if (PrivateDiscussionUsers[j].userId !== this._currentUser.user.id) {
        //                             usersData.push({
        //                                 user: this._utils.findIn(PrivateDiscussionUsers[j].userId, storageData[3], 'id'),
        //                                 PrivateDiscussionUser: PrivateDiscussionUsers[j]
        //                             });
        //                         }
        //                     }
        //                     const privateDiscussionData: PrivateDiscussionData = {
        //                         privateDiscussion,
        //                         PrivateDiscussionUser,
        //                         usersData,
        //                         discussion,
        //                         messages,
        //                         unreadMessagesCount: unreadCount
        //                     };
        //                     if (dataIndex >= 0) {
        //                         this._privateDiscussionsData.push(privateDiscussionData);
        //                     } else {
        //                         this._privateDiscussionsData.splice(0, 0, privateDiscussionData);
        //                     }
        //
        //                     resolve(privateDiscussionData);
        //                 })
        //                 .catch((error: any) => reject(error));
        //         })
        //         .catch((error: any) => reject(error));
    }

    private loadPrivateDiscussionsData(): Observable<any> {
      throw new Error('Method not implemented.');
        // return new Promise<any[]>((resolve, reject) => {
        //     if (!this._currentUser.isLoggedIn()) {
        //         this._privateDiscussionsData = [];
        //         resolve();
        //         return;
        //     }
        //
        // this.api.call('get', `private-discussion-user/${this._currentUser.user?.id}`, {}, this._currentUser.getAccessToken())
        //     this._storage.select(PrivateDiscussionUser).where('userId').equals(this._currentUser.user.id).get()
        //         .then((PrivateDiscussionUsers: PrivateDiscussionUser[]) => {
        //             const privateDiscussionIds: number[] = this._utils.getKeyValues(PrivateDiscussionUsers, 'privateDiscussionId');
        //             Promise.all([
        //                 this._storage.fromIds(PrivateDiscussion, privateDiscussionIds),
        //                 this._storage.select(PrivateDiscussionUser)
        //                     .where('privateDiscussionId').in(privateDiscussionIds)
        //                     .and('userId').notEquals(this._currentUser.user.id)
        //                     .get()
        //             ])
        //                 .then((data1: any[]) => {
        //                     const discussionIds: number[] = this._utils.getKeyValues(data1[0], 'discussionId');
        //                     const userIds: number[] = this._utils.getKeyValues(data1[1], 'userId', true);
        //                     Promise.all([
        //                         this._storage.fromIds(Discussion, discussionIds),
        //                         this._storage.select(DiscussionMessage).where('discussionId').in(discussionIds).get(),
        //                         this._storage.fromIds(User, userIds, true)
        //                     ])
        //                         .then((data2: any[]) => {
        //                             const data: PrivateDiscussionData[] = [];
        //                             const unreadData: PrivateDiscussionData[] = [];
        //                             for (let i = 0; i < data1[0].length; i++) {
        //                                 const usersData: PrivateDiscussionUserData[] = [];
        //                                 for (let j = 0; j < data1[1].length; j++) {
        //                                     if (data1[1][j].privateDiscussionId === data1[0][i].id) {
        //                                         usersData.push({
        //                                             user: this._utils.findIn(data1[1][j].userId, data2[2], 'id'),
        //                                             PrivateDiscussionUser: data1[1][j]
        //                                         });
        //                                     }
        //                                 }
        //
        //                                 const PrivateDiscussionUser: PrivateDiscussionUser = this._utils.findIn(data1[0][i].id, PrivateDiscussionUsers, 'privateDiscussionId');
        //                                 const messages: DiscussionMessage[] = this._utils.findManyIn([data1[0][i].discussionId], data2[1], 'discussionId');
        //                                 const unreadMessagesCount: number = this.countUnreadMessages(PrivateDiscussionUser, messages);
        //                                 const privateDiscussionData: PrivateDiscussionData = {
        //                                     privateDiscussion: data1[0][i],
        //                                     PrivateDiscussionUser,
        //                                     usersData,
        //                                     discussion: this._utils.findIn(data1[0][i].discussionId, data2[0], 'id'),
        //                                     messages,
        //                                     unreadMessagesCount
        //                                 };
        //                                 data.push(privateDiscussionData);
        //                                 if (unreadMessagesCount > 0) {
        //                                     unreadData.push(privateDiscussionData);
        //                                 }
        //                             }
        //
        //                             this._privateDiscussionsData = this.sortPrivateDiscussionsData(data);
        //                             this._privateDiscussionsDataWithUnreadMessages = unreadData;
        //                             resolve();
        //                         })
        //                         .catch((error) => reject(error));
        //                 })
        //                 .catch((error) => reject(error));
        //         })
        //         .catch((error) => reject(error));
        // });
    }

    private updateActivePrivateDiscussion(): void {
        let i = 0;
        while (i < this._activePrivateDiscussions.length) {
            let found = false;
            for (let j = 0; !found && j < this._privateDiscussionsData.length; j++) {
                if (this._privateDiscussionsData[j].privateDiscussion.id === this._activePrivateDiscussions[i].data.privateDiscussion.id) {
                    found = true;
                    this._activePrivateDiscussions[i].data = this._privateDiscussionsData[j];
                }
            }

            if (!found) {
                this._activePrivateDiscussions.splice(i, 1);
            } else {
                i++;
            }
        }
    }

    private countUnreadMessages(PrivateDiscussionUser: PrivateDiscussionUser, messages: DiscussionMessage[]): number {
        if (!PrivateDiscussionUser.lastSeen) {
            return messages.length;
        }

        let count = 0;
        for (let i = 0; i < messages.length; i++) {
            if (messages[i].createDate! > PrivateDiscussionUser.lastSeen) {
                count++;
            }
        }

        return count;
    }

    private sortPrivateDiscussionsData(data: PrivateDiscussionData[]): PrivateDiscussionData[] {
        data.sort((a: PrivateDiscussionData, b: PrivateDiscussionData) => {
            let aDate: string = a.privateDiscussion.createDate!;
            if (a.messages.length > 0) {
                aDate = a.messages[a.messages.length - 1].createDate!;
            }
            let bDate: string = b.privateDiscussion.createDate!;
            if (b.messages.length > 0) {
                bDate = b.messages[b.messages.length - 1].createDate!;
            }

            return aDate < bDate ? 1 : -1;
        });

        return data;
    }
}

export interface PrivateDiscussionUserData {
    user: User;
    PrivateDiscussionUser: PrivateDiscussionUser;
}

export interface PrivateDiscussionData {
    privateDiscussion: PrivateDiscussion;
    PrivateDiscussionUser: PrivateDiscussionUser;
    usersData: PrivateDiscussionUserData[];
    discussion: Discussion;
    messages: DiscussionMessage[];
    unreadMessagesCount: number;
}

export interface ActivePrivateDiscussion {
    data: PrivateDiscussionData;
    isMinimized: boolean;
    isReady: boolean;
}
